// Local translations
export const T = {
  en_GB: {
    portfolioSourceHelp:
      "Existing portfolio lists the client's holdings before advice. It applies to follow up portfolios; other portfolios show the new portfolio.",
  },
  nb_NO: {
    portfolioSourceHelp:
      "Eksisterende portefølje viser kundens beholdning før rådgivning. Gjelder oppfølgingsporteføljer; andre porteføljer viser den nye porteføljen.",
  },
} as const;
